// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root.tsx'
import { Route as IndexRouteImport } from './routes/index.tsx'
import { Route as PrivacyPolicyRouteImport } from './routes/privacy-policy.tsx'
import { Route as TermsOfServiceRouteImport } from './routes/terms-of-service.tsx'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const PrivacyPolicyRoute = PrivacyPolicyRouteImport.update({
            id: '/privacy-policy',path: '/privacy-policy',getParentRoute: () => rootRouteImport
          })
const TermsOfServiceRoute = TermsOfServiceRouteImport.update({
            id: '/terms-of-service',path: '/terms-of-service',getParentRoute: () => rootRouteImport
          })

const rootRouteChildren = {
  IndexRoute: IndexRoute,PrivacyPolicyRoute: PrivacyPolicyRoute,TermsOfServiceRoute: TermsOfServiceRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)